var _circle, _circle2, _g, _circle3, _circle4, _g2, _circle5, _circle6, _g3, _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceNaturalLightExposure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 145,
    viewBox: "0 0 282 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 71,
    r: 32,
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 39,
    width: 64,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 71,
    r: 32,
    fill: "#D56D37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5385,
    cy: 68.5385,
    r: 29.5385,
    fill: "#EEAA3C"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 71,
    r: 32,
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11322_9760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 39,
    width: 64,
    height: 64
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 71,
    r: 32,
    fill: "#D56D37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11322_9760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.538,
    cy: 68.5385,
    r: 29.5385,
    fill: "#EEAA3C"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 71,
    r: 40,
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11322_9760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 31,
    width: 80,
    height: 80
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 71,
    r: 40,
    fill: "#D56D37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11322_9760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220.923,
    cy: 67.9231,
    r: 36.9231,
    fill: "#EEAA3C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.693 39.4609C194.135 39.4609 196.282 40.7257 197.515 42.6361C197.872 42.5716 198.24 42.5379 198.616 42.5379C201.308 42.5379 203.597 44.267 204.432 46.6753C205.023 46.4861 205.654 46.384 206.308 46.384C209.707 46.384 212.462 49.1392 212.462 52.5379C212.462 55.9365 209.707 58.6917 206.308 58.6917H184.001C180.602 58.6917 177.847 55.9365 177.847 52.5379C177.847 49.1392 180.602 46.384 184.001 46.384C184.261 46.384 184.518 46.4002 184.77 46.4316L184.77 46.384C184.77 42.5605 187.869 39.4609 191.693 39.4609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.307 51.7686C253.865 51.7686 251.718 53.0334 250.485 54.9437C250.128 54.8792 249.76 54.8455 249.384 54.8455C246.692 54.8455 244.403 56.5746 243.568 58.9829C242.977 58.7938 242.346 58.6916 241.692 58.6916C238.293 58.6916 235.538 61.4468 235.538 64.8455C235.538 68.2442 238.293 70.9993 241.692 70.9993H263.999C267.398 70.9993 270.153 68.2442 270.153 64.8455C270.153 61.4468 267.398 58.6916 263.999 58.6916C263.739 58.6916 263.482 58.7078 263.23 58.7393L263.23 58.6916C263.23 54.8681 260.131 51.7686 256.307 51.7686Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 101L156.5 105L163.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 101L60.5 105L67.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 138,
    r: 2,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 31,
    r: 2,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 29.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 9.5L197.5 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 7.5L253.5 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 130L207.5 142.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceNaturalLightExposure);
export default __webpack_public_path__ + "static/media/persistence-natural-light-exposure.00f0e37256984ca344cdb914763e4169.svg";
export { ForwardRef as ReactComponent };